module.exports = __webpack_public_path__ + "images/district_back.1792033684119.png";